import {Component, Prop, Vue} from 'vue-property-decorator';
import CalendarDetailRecord from '@/components/CalendarDetail/CalendarDetailRecord/CalendarDetailRecord.vue';
import CalendarDetailWorkPlan from "@/components/CalendarDetail/CalendarDetailWorkPlan/CalendarDetailWorkPlan.vue";
import {PlantingPlanIds} from '@/types';
@Component({
    components: {
        CalendarDetailRecord,
        CalendarDetailWorkPlan
    },
})
export default class CalendarDetail extends Vue {

    @Prop()
    private selectedPlantingPlanIds!: PlantingPlanIds;

    @Prop()
    private selectedDate!: string;

    @Prop()
    isFilteredUpdated!: boolean;

    @Prop()
    private selectedType!: 'day' | 'planting';

    @Prop()
    private openDetail!: boolean

    private deleteRecord(id: string) {
        this.$emit('deleteRecord', id);
    }

    private closeDetail() {
        this.$emit('closeDetail')
    }
}